export default "__VITE_PUBLIC_ASSET__72ed8e5c__"